import {
  AddLeadActivityNodeDataSchema,
  CompleteTaskNodeDataSchema,
  CreateTaskNodeDataSchema,
  DistributeLeadNodeDataSchema,
  SendEmailNodeDataSchema,
  UpdateLeadNodeDataSchema,
  WebhookNodeDataSchema,
} from './nodeSchemas/actionNodes';
import {
  CompareNodeDataSchema,
  ElseNodeDataSchema,
  IfElseNodeDataSchema,
  IfNodeDataSchema,
  MultiIfElseNodeDataSchema,
  WaitNodeDataSchema,
} from './nodeSchemas/conditionNodes';
import { CommonNodeDataSchema } from './nodeSchemas/node';
import {
  LeadActivityCreateNodeDataSchema,
  LeadActivityUpdateNodeDataSchema,
  LeadCreateNodeDataSchema,
  LeadUpdateNodeDataSchema,
  TaskCreateNodeDataSchema,
  TriggerNodeDataSchema,
  UserCreateNodeDataSchema,
  UserUpdateNodeDataSchema,
} from './nodeSchemas/triggerNodes';

export const nodeSchemas = {
  CommonNodeData: CommonNodeDataSchema,
  TriggerNodeData: TriggerNodeDataSchema,
  LeadCreateNodeData: LeadCreateNodeDataSchema,
  LeadUpdateNodeData: LeadUpdateNodeDataSchema,
  LeadActivityCreateNodeData: LeadActivityCreateNodeDataSchema,
  LeadActivityUpdateNodeData: LeadActivityUpdateNodeDataSchema,
  TaskCreateNodeData: TaskCreateNodeDataSchema,
  CompleteTaskNodeData: CompleteTaskNodeDataSchema,
  IfElseNodeData: IfElseNodeDataSchema,
  WaitNodeData: WaitNodeDataSchema,
  CompareNodeData: CompareNodeDataSchema,
  MultiIfElseNodeData: MultiIfElseNodeDataSchema,
  IfNodeData: IfNodeDataSchema,
  ElseNodeData: ElseNodeDataSchema,
  UpdateLeadActionNodeData: UpdateLeadNodeDataSchema,
  WebhookActionNodeData: WebhookNodeDataSchema,
  DistributeLeadActionNodeData: DistributeLeadNodeDataSchema,
  SendEmailActionNodeData: SendEmailNodeDataSchema,
  CreateTaskActionNodeData: CreateTaskNodeDataSchema,
  AddLeadActivityActionNodeData: AddLeadActivityNodeDataSchema,
  UserCreateNodeData: UserCreateNodeDataSchema,
  UserUpdateNodeData: UserUpdateNodeDataSchema,
};

export * from './nodeSchemas';
